import 'ng-csv';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './budgetsTable.jade';

export class BudgetsTableController {
  /* @ngInject */
  constructor($stateParams,GamesResource,CampaignsResource,CampaignAnalyticsResource, BudgetAnalyticsResource,CohortsResource,$filter,$localStorage,notify){
    this.$stateParams = $stateParams;
    this.GamesResource = GamesResource;
    this.CampaignsResource = CampaignsResource;
    this.CampaignAnalyticsResource = CampaignAnalyticsResource;
    this.BudgetAnalyticsResource = BudgetAnalyticsResource;
    this.CohortsResource = CohortsResource;
    this.translate = $filter('translate');
    this.apiDate = $filter('apiDate');
    this.notify = notify;
    this.$localStorage = $localStorage;

    this.timeframe = normalizeTimeframe(this.timeframe || this.$localStorage.timeframe);
    this.timeframeChange = this.timeframeChange || new Rx.BehaviorSubject(this.timeframe);
    this.timeframeChange.subscribe((timeframe) => {
      this.timeframe = timeframe;
      this.getBudgetsStatistics();
      this.getCampaignsRoi7();
    });
    this.getCampaigns({game_id: $stateParams.gameId, segment_id: $stateParams.id});
    this.getCurrency();
  }

  getCampaigns({game_id,segment_id}) {
    return this.CampaignsResource.getList({game_id,segment_id})
        .then(campaigns => { this.budgetsTable.loadData(campaigns); })
        .then(() => this.getBudgetsStatistics())
        .then(() => this.getCampaignsRoi7())
  }

  getBudgetsStatistics(){
    (this.budgetsTable.loadedData||[]).forEach(campaign => {
      if (campaign.type == 'Acquisition' || campaign.type == 'AcquisitionCPM' || campaign.type == 'BrandingCPM') {
        // Removed in PEP-4438
      } else {
        campaign.roi_d7 = 'Loading...';
        this.getEngagementCampaignStatistics(campaign);
      }
    });
  }

  getCampaignsRoi7() {
    let query = {
      game_id: this.$stateParams.gameId,

      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),

      breakdown_dimension: 'campaign_id',
      metric: 'roi',
      campaign_type: 'Engagement,EngagementCPC,EngagementCPA,EngagementCPI,Organic,Acquisition,AcquisitionCPM,BrandingCPM',
    };

    this.CohortsResource.one().get(query)
        .then(result => {
          (this.budgetsTable.loadedData||[]).forEach(campaign => {
            const campaignRow = _.find(result.data.rows, r => r.key && parseInt(r.key) === campaign.id);
            campaign.roi_d7 = campaignRow !== undefined ? campaignRow.d7 : 0;
          });
        });
  }

  getCurrency() {
    this.currency = 'USD';
  }

  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  getEngagementCampaignStatistics(campaign) {
    this.BudgetAnalyticsResource.one('overview').get({
      campaign_id: campaign.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate)
    }).then((res) => {
      campaign.media_cost = res.data.media_cost;
      campaign.engaged_players = res.data.engaged_players;
      campaign.margin = res.data.margin;
      campaign.profit = res.data.profit;
      campaign.cost = res.data.cost;
      campaign.ecpa = res.data.ecpa;
      campaign.app_open = res.data.app_open;
    })
  }

  isBudgetCappingTypeMonetary() {
    return this.campaign.budget_capping_type == 'Monetary';
  }

  isBudgetCappingTypeClicks() {
    return this.campaign.type == 'EngagementCPC' && this.campaign.budget_capping_type == 'Event';
  }

  isBudgetCappingTypeConversions() {
    return this.campaign.type == 'EngagementCPA' && this.campaign.budget_capping_type == 'Event';
  }

  isEngagementTypeCampaign() {
    return this.campaign.type == "Engagement" || this.campaign.type == "EngagementCPC" || this.campaign.type == "EngagementCPA"
  }

  isCampaignOfPlatformType(campaign, value) {
    return campaign.urls && campaign.urls[value];
  }

  getAutoPilotStyle(campaign) {
    if (campaign.autopilot_launcher_message !== null) {
      return {
        'text-decoration': 'line-through',
        'text-decoration-color': 'rgba(240, 255, 0, 0.6)',
        'text-decoration-thickness': '0.4em'
      }
    }
    return {};
  }
}

export function BudgetsTableComponent() {
  return {
    template,
    controller: BudgetsTableController,
    transclude: true,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      budgetsTable: '=',
      timeframeChange: '=?',
      segment: '=?'
    },
    bindToController: true,
    link: function(scope,element,attrs,ctrl, transclude) {
      element.find('ng-transclude').replaceWith(transclude());
    }
  };
};

export default angular.module('app.components.budgets.index', [
  'ngCsv',
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
.directive('budgetsTable', BudgetsTableComponent);



/** WEBPACK FOOTER **
 ** ./src/components/budget/budgetsTable.js
 **/